export default __webpack_public_path__ + "static/media/ms.10eeaa5a.jpg";